'use strict';
var logger = require('./logger.js');
var localStorageUtils = require('./local-storage-utils.js');
var localStorageConstants = require('./local-storage-constants.js');
var sourcepointConstants = require('./sourcepoint-constants.js');

var permutive = window.permutive;

function onConsentGranted () {
    logger.info('ermutive consent has been granted - data will be collected');
	permutive.consent({ 'opt_in': true, 'token': 'CONSENT_CAPTURED' });
}

function onConsentRefused () {
	logger.info('Permutive consent has not been granted - no data will be collected');
	permutive.consent({ 'opt_in': false });
}

permutive.init = function() {
    const storedConsent = localStorageUtils.getItem(localStorageConstants.consentDataKey);
    if (!storedConsent) {
        logger.warning('Failed to initialise permutive: No consent data');
        return;
    }

    const hasPermutiveConsent = storedConsent.consentedVendors.includes(sourcepointConstants.vendorIds.permutive);
    if (hasPermutiveConsent) {
        onConsentGranted();
    } else {
        onConsentRefused();
    }
};

module.exports = permutive;